import StandardOverview from '@rebuild/materials/shared/quote/standard/FlowOverview.vue';

export const componentMap = {
	overview: StandardOverview
};
